import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { uiActions } from '../../actions/index';
import ActivityToday from './ActivityToday';
import ActivityAddTime from './ActivityAddTime';
import ProjectCreateOrEdit from './../projects/ProjectCreateOrEdit';
import ActivitySelectProject from './ActivitySelectProject';
import './Activity.css';
import WorkLogsPerDay from './WorkLogsPerDay';

class Activity extends React.Component {
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(uiActions.activityAddTimeClicked());
    dispatch(uiActions.activityAddClicked(false));
    dispatch(uiActions.addProjectClicked(false));
    dispatch(uiActions.workLogBlockClicked());
  }

  renderRightComponent() {
    const {
      addTimeProject,
      isAddProject,
      isSelectProject,
      workLogsPerDayProject,
    } = this.props;
    if (addTimeProject) {
      return <ActivityAddTime />;
    }
    if (workLogsPerDayProject) {
      return <WorkLogsPerDay />;
    }
    if (isAddProject) {
      return <ProjectCreateOrEdit />;
    }
    if (isSelectProject) {
      return <ActivitySelectProject />;
    }
    return <div />;
  }

  render() {
    return (
      <div className="activity-root">
        <ActivityToday />
        {this.renderRightComponent()}
      </div>
    );
  }
}

Activity.propTypes = {
  dispatch: PropTypes.func.isRequired,
  addTimeProject: PropTypes.shape().isRequired,
  isAddProject: PropTypes.bool.isRequired,
  isSelectProject: PropTypes.bool.isRequired,
  workLogsPerDayProject: PropTypes.shape().isRequired,
};

const mapStateToProps = state => ({
  addTimeProject: state.uiState.addTimeProject,
  isAddProject: state.uiState.isAddProject,
  isSelectProject: state.uiState.isSelectProject,
  workLogsPerDayProject: state.uiState.workLogsPerDayProject,
});

export default connect(mapStateToProps)(Activity);



// WEBPACK FOOTER //
// ./src/components/activity/Activity.js